export default __webpack_public_path__ + "static/media/ww3.4004dd2e.jpg";